import { ScannedHistoryServices } from '../services';
import { ScannedHistoryConstants } from '../constants';
import { alertActions } from '.';

export const ScannedHistoryActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());
        ScannedHistoryServices.fetchVerificationData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows; delete v.ProductId });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: ScannedHistoryConstants.GETALL_REQUEST } }
    function success(datas) { return { type: ScannedHistoryConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: ScannedHistoryConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: ScannedHistoryConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        ScannedHistoryServices.fetchVerificationData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows; delete v.ProductId });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: ScannedHistoryConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: ScannedHistoryConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: ScannedHistoryConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: ScannedHistoryConstants.LOADING_REQUEST, isbool
    }
}
